import Text from '@components/Text/Text';
import {
  Container,
  StyledLabel,
  StyledValueContainer,
  StyledMultiValue,
} from './LabelValueTextPair.styles';

export interface LabelValueTextPairProps {
  label: React.ReactNode;
  value: string | string[];
  valueTextDirection?: 'column' | 'row' | 'column-reverse' | 'row-reverse';
}

const LabelValueTextPair: React.FC<LabelValueTextPairProps> = ({
  label,
  value,
  valueTextDirection = 'row',
}) => {
  return (
    <Container>
      <StyledLabel variant='h6' fontWeight='fontWeightSemiBold'>
        {label}
      </StyledLabel>
      <StyledValueContainer sx={{ flexDirection: valueTextDirection }}>
        {Array.isArray(value) ? (
          <>
            {value.map((v) => (
              <StyledMultiValue
                key={v}
                variant='body'
                fontWeight='fontWeightRegular'
              >
                {v}
              </StyledMultiValue>
            ))}
          </>
        ) : (
          <>
            {value &&
              value.split('\n').map((v) => (
                <Text key={v} variant='body' fontWeight='fontWeightRegular'>
                  {v}
                </Text>
              ))}
          </>
        )}
      </StyledValueContainer>
    </Container>
  );
};

export default LabelValueTextPair;
